import React, { Component, Fragment } from 'react'
import ReactDOM from 'react-dom'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'

import { config } from 'config/config'

import { withCookieNotice } from '@/store/context/cookie-notice-context'

import {
  cookieCategoryIsActive,
  getEncryptedCookie,
} from '@/modern/utils/cookies'

import { fetchProposal } from 'ducks/proposal'

import {
  phoneMask,
  insertQueryParameter,
  handleLeadCookie,
  handleFormCookie,
  setEventToLazyDispatch,
  getDataLayerUrl,
  getCookieChannel,
  getItemUrl,
  getItemUrlOrigin,
  onClientSide,
  getCurrentChannel,
  sendDispatchEvent,
} from '@/utils/utils'
import {
  AD_TYPE,
  COOKIES,
  MESSAGE_LEAD,
  SYSTEM,
  CHANNEL,
  COOKIE_NOTICE_TYPES,
} from 'utils/constants'

import Button from 'components/Button'
import Input from 'components/Input'
import { dispatchInsiderTrack } from '@/modern/tracking/insiderTrack'
import { insiderEventModel } from '@/modern/tracking/insiderTrack/utils'
import { useTargetApi as targetApi } from '@/modern/hooks/useTargetApi'
import { addFinancingDataItem } from '@/modern/hooks/useFinancing'
import {
  getFBCLIDFromUrl,
  getGCLIDFromUrl,
  getMCMIDFromCookie,
} from '@/modern/hooks/useTargetApi/getVisitorData'
import FormDetails from '.'
import AdPlacement from '../AdPlacement';

class SendProposal extends Component {
  constructor(props) {
    super(props)

    const { cookieNoticeContext } = this.props
    const { cookies } = cookieNoticeContext

    this.cookiesState = {
      formData: cookieCategoryIsActive(cookies, COOKIES.FORM_DATA),
      sentLeads: cookieCategoryIsActive(cookies, COOKIES.SENT_LEADS),
      channel: cookieCategoryIsActive(cookies, COOKIES.CHANNEL),
    }

    this.state = {
      showFormErrors: true,
      fullName: '',
      fullNameCookie: '',
      fullNameError: true,
      email: '',
      emailCookie: '',
      emailError: true,
      numberPhone: '',
      numberPhoneCookie: '',
      numberPhoneError: 'true',
      message: MESSAGE_LEAD.ONE,
      messageCookie: '',
      messageError: MESSAGE_LEAD.ONE ? false : true,
      newsletter: false,
      newsletterCookie: false,
      editForm: false,
      buttonEdit: false,
      loadingMessage: false,
      updateInformations: true,
      fixedForms: false,
      ABFormTest: false,
      wantCarDelivery: false,
    }
    this.handleChangeInputs = this.handleChangeInputs.bind(this)
    this.sendProposal = this.sendProposal.bind(this)
    this.handleClickSeeParcels = this.handleClickSeeParcels.bind(this)
    this.handleScrollForms = this.handleScrollForms.bind(this)
  }
  componentDidUpdate(prevProps) {
    const oldCookies = prevProps.cookieNoticeContext.cookies
    const { cookies } = this.props.cookieNoticeContext

    if (
      JSON.stringify(oldCookies[COOKIE_NOTICE_TYPES.PROPOSALS]) !==
      JSON.stringify(cookies[COOKIE_NOTICE_TYPES.PROPOSALS])
    ) {
      this.cookiesState = {
        ...this.cookiesState,
        formData: cookieCategoryIsActive(cookies, COOKIES.FORM_DATA),
        sentLeads: cookieCategoryIsActive(cookies, COOKIES.SENT_LEADS),
      }

      if (cookies[COOKIE_NOTICE_TYPES.PROPOSALS] === false) {
        this.setState({
          showFormErrors: true,
          fullName: '',
          fullNameCookie: '',
          fullNameError: true,
          email: '',
          emailCookie: '',
          emailError: true,
          numberPhone: '',
          numberPhoneCookie: '',
          numberPhoneError: 'true',
          message: MESSAGE_LEAD.ONE,
          messageCookie: '',
          messageError: MESSAGE_LEAD.ONE ? false : true,
          newsletter: false,
          newsletterCookie: false,
          editForm: true,
          buttonEdit: false,
        })
      }
    } else if (
      JSON.stringify(oldCookies[COOKIE_NOTICE_TYPES.MARKETING]) !==
      JSON.stringify(cookies[COOKIE_NOTICE_TYPES.MARKETING])
    ) {
      this.cookiesState = {
        ...this.cookiesState,
        channel: cookieCategoryIsActive(cookies, COOKIES.CHANNEL),
      }
    }
  }
  componentDidMount() {
    if (onClientSide()) {
      window.addEventListener('scroll', this.handleScrollForms, false)
      document
        .querySelector('.Forms__vehicleSendProposal__container')
        .classList.remove('Forms__vehicleSendProposal__container--static')
    }
    this.checkABTest()
  }
  componentWillUnmount() {
    if (onClientSide()) {
      window.removeEventListener('scroll', this.handleScrollForms, false)
      document
        .querySelector('.Forms__vehicleSendProposal__container')
        .classList.remove('Forms__vehicleSendProposal__container--static')
    }
  }
  checkABTest(retry) {
    if (
      !this.state.ABFormTest &&
      typeof WMTests !== 'undefined' &&
      WMTests.leadForm
    ) {
      this.setState({ ABFormTest: true })
    } else if (!retry) {
      setTimeout(() => {
        this.checkABTest(true)
      }, 2000)
    }
  }
  handleScrollForms() {
    if (
      onClientSide() &&
      this.refs.FormsSendProposal &&
      this.refs.proposalContainer
    ) {
      let lastElement = document.querySelector('.InformationVehicleDetails')
        .lastElementChild
      let firstElement = document.querySelector('.InformationVehicleDetails')
        .firstElementChild
      if (
        this.refs.proposalInnerContainer.getBoundingClientRect().top <
        firstElement.getBoundingClientRect().top
      ) {
        this.setState({ fixedForms: false })
      } else if (
        firstElement.getBoundingClientRect().top < 90 &&
        window.innerHeight - lastElement.getBoundingClientRect().bottom < 40
      ) {
        this.setState({ fixedForms: 'fixed' })
      } else if (firstElement.getBoundingClientRect().top < 90) {
        this.setState({ fixedForms: 'bottom' })
      }
    }
  }
  componentWillReceiveProps(nextProps) {
    if (this.state.updateInformations) {
      this.checkFormCookie()
    }
  }
  handleChangeInputs(e) {
    let targetName = e.target.name
    this.setState({ [targetName]: e.target.value })
  }
  handleCheckChange(value) {
    this.setState({ newsletter: value })
  }
  formValidation = (error, name) => {
    this.setState({ [name + 'Error']: error }, () => {
      this.setState({
        showFormErrors:
          !this.state.emailError &&
            !this.state.fullNameError &&
            !this.state.numberPhoneError &&
            !this.state.messageError
            ? false
            : true,
      })
    })
  }

  sendProposal() {
    sendDispatchEvent('formProposalComprar')

    const { handleSendProposal, dataForm, cookieNoticeContext, ad } = this.props
    const { cookies } = cookieNoticeContext

    dispatchInsiderTrack({
      properties: insiderEventModel({
        details: ad,
        eventName: 'purchase',
      }),
    })

    handleSendProposal()
    const isCookieCategoryActive = cookieCategoryIsActive(
      cookies,
      COOKIES.TRACKING_FROM
    )

    if (!this.state.showFormErrors && !this.state.loadingMessage) {
      this.setState({ loadingMessage: true, updateInformations: false })
      document
        .querySelector('.Button--send-message')
        .classList.add('Button--send-message--loading')

      const {
        fullName,
        email,
        numberPhone,
        message,
        newsletter,
        wantCarDelivery,
      } = this.state
      const { uniqueId, vehicleType, listingType, idGuid } = dataForm

      let _cookieChannel = this.cookiesState.channel && getCurrentChannel()
      let _channel = CHANNEL.WEBMOTORS

      const params = getDataLayerUrl(this.props.location)

      const messageWithCarDelivery =
        message +
        'Tenho interesse em realizar a negociação através do Car Delivery'
      const formattedMessage =
        wantCarDelivery && this.props.isPJ ? messageWithCarDelivery : message

      const offers = this.state.newsletter ? 1 : 2
      const fbclid = getFBCLIDFromUrl(this.props.location.search)
      const gclid = getGCLIDFromUrl(this.props.location.search)

      this.props.handleSendProposal(wantCarDelivery, this.props.isPJ, offers)

      if (params.hd) {
        _channel = CHANNEL.FEIRAO
      } else {
        if (_cookieChannel) {
          if (_cookieChannel == SYSTEM.MEUCARANGO) _channel = CHANNEL.MEUCARANGO
          else if (_cookieChannel == SYSTEM.COMPREAUTO)
            _channel = CHANNEL.COMPREAUTO
          else if (_cookieChannel == SYSTEM.ITAJAICARROS)
            _channel = CHANNEL.ITAJAICARROS
          else if (_cookieChannel == SYSTEM.FLORIPACARROS)
            _channel = CHANNEL.FLORIPACARROS
          else if (_cookieChannel == SYSTEM.BLUCARROS)
            _channel = CHANNEL.BLUCARROS
          else if (_cookieChannel == SYSTEM.JOINVILLECARROS)
            _channel = CHANNEL.JOINVILLECARROS
        }
      }

      var adobeGuid = null
      if (
        process.env.NODE_ENV != 'development' &&
        typeof Visitor != 'undefined' &&
        Visitor != null &&
        Visitor.getInstance('3ADD33055666F1A47F000101@AdobeOrg') != null &&
        Visitor.getInstance('3ADD33055666F1A47F000101@AdobeOrg') != undefined &&
        Visitor.getInstance(
          '3ADD33055666F1A47F000101@AdobeOrg'
        ).getMarketingCloudVisitorID() != null &&
        Visitor.getInstance(
          '3ADD33055666F1A47F000101@AdobeOrg'
        ).getMarketingCloudVisitorID() != undefined
      ) {
        adobeGuid = Visitor.getInstance(
          '3ADD33055666F1A47F000101@AdobeOrg'
        ).getMarketingCloudVisitorID()
      }

      if (!adobeGuid) {
        adobeGuid = getMCMIDFromCookie()
      }

      const _data = {
        IdAnuncio: uniqueId,
        TipoVeiculo: vehicleType,
        Nome: fullName.trim(),
        Email: email.trim(),
        Telefone: phoneMask(numberPhone),
        Mensagem: formattedMessage.trim(),
        TipoAnuncio: listingType === AD_TYPE.NEW ? 'novos' : 'usados',
        Origem: 'D',
        IdGuid: idGuid,
        QueroReceberPesquisa: newsletter,
        Canal: _channel,
        AdobeGuid: adobeGuid,
        FBCLID: fbclid,
        GCLID: gclid,
      }

      if (onClientSide()) {
        const key = config.hideModalPromoBlackFairao2024;
        if (key && window.localStorage.getItem(key) !== null) {
          window.localStorage.removeItem(key);
        }
      }

      this.props.dispatch(fetchProposal(_data, () => {
        sendDispatchEvent('formProposalComprarSuccess')
      })).then(() => {
        this.handleMessageSuccess()
      })

      if (isCookieCategoryActive) {
        setEventToLazyDispatch('envioPropostaDetalhe')
      }
    } else {
      if (this.state.ABFormTest) {
        let _elements = ['nameInput', 'emailInput', 'phoneInput']
        for (let i = 0; i < _elements.length; i++) {
          let _element = ReactDOM.findDOMNode(
            this.refs[_elements[i]]
          ).querySelector('input')
          _element.focus()
          _element.blur()
        }
      }
    }
  }

  checkFormCookie() {
    const cookieFormData =
      this.cookiesState.formData && getEncryptedCookie(COOKIES.FORM_DATA)

    if (cookieFormData) {
      const {
        email,
        fullName,
        numberPhone,
        newsletter,
      } = cookieFormData.Principal

      this.setState({
        email,
        emailCookie: email,
        emailError: false,
        fullName,
        fullNameCookie: fullName,
        fullNameError: false,
        numberPhone,
        numberPhoneCookie: `${numberPhone.substring(0, 9)}...`,
        numberPhoneError: false,
        showFormErrors: false,
        newsletter,
        newsletterCookie: newsletter,
        buttonEdit: true,
        editForm: false,
        updateInformations: true,
      })
    }
  }

  handleMessageSuccess() {
    handleLeadCookie(this.props.dataForm.uniqueId, this.cookiesState.sentLeads)
    handleFormCookie(
      {
        fullName: this.state.fullName,
        email: this.state.email,
        numberPhone: this.state.numberPhone,
        message: this.state.message,
        newsletter: this.state.newsletter,
      },
      this.cookiesState.formData
    )
    this.setState({ loadingMessage: false }, () => {
      document
        .querySelector('.Button--send-message')
        .classList.remove('Button--send-message--loading')
    })
    this.props.history.push('/mensagem-enviada' + this.renderSentUrl())
  }
  renderSentUrl() {
    let url = ''
    url = insertQueryParameter(url, 'id', this.props.dataForm.uniqueId)
    url = insertQueryParameter(
      url,
      'tipoveiculo',
      this.props.dataForm.vehicleType
    )

    if (this.props.match && this.props.match.params && this.props.match.params.make) {
      url = insertQueryParameter(url, 'brand', this.props.match.params.make)
      url = insertQueryParameter(url, 'model', this.props.match.params.model)
      url = insertQueryParameter(url, 'year', this.props.match.params.years)

      if (this.props.match.params.buyCar) {
        url = insertQueryParameter(url, 'version', this.props.match.params.version)
        url = insertQueryParameter(url, 'doors', this.props.match.params.doors)
      } else {
        url = insertQueryParameter(url, 'cc', this.props.match.params.version)
      }
    }

    if (this.props.fromShielding) url = insertQueryParameter(url, 'bld', '1')

    const params = getDataLayerUrl(this.props.location)
    if (params.hd)
      url = insertQueryParameter(url, 'hd', decodeURIComponent(params.hd))

    let _cookieChannel = this.cookiesState.channel && getCookieChannel()
    if (_cookieChannel)
      url = insertQueryParameter(url, 'origem', _cookieChannel)

    let _lojas = getItemUrlOrigin(this.props.location.search, 'orilojas')
    if (_lojas)
      url = insertQueryParameter(url, 'orilojas', _lojas.KEY.toLowerCase())

    let _recomendacao = getItemUrlOrigin(this.props.location.search, 'orirecom')
    if (_recomendacao)
      url = insertQueryParameter(
        url,
        'orirecom',
        _recomendacao.KEY.toLowerCase()
      )

    let _categoria = getItemUrl(this.props.location.search, 'ct')
    if (_categoria) url = insertQueryParameter(url, 'ct', _categoria)

    return url ? '?' + url : ''
  }
  editForm() {
    this.setState({
      editForm: true,
      buttonEdit: false,
      updateInformations: false,
    })
  }

  handlerFinancingForm(financingForm) {
    if (financingForm) {
      const dataFinancingForm = {
        ad: financingForm.ad || {},
        cookieNoticeContext: financingForm.cookieNoticeContext || {},
        dataForm: financingForm.dataForm || {},
        isPJ: financingForm.isPJ,
        location: financingForm.location || {},
        datalayer: financingForm.datalayer,
        photos: financingForm.photos || {},
      }

      addFinancingDataItem(financingForm.ad.UniqueId, dataFinancingForm)
    }
  }

  handleClickSeeParcels() {
    const { ad, clickScrollSimulation, location, isPJ, history } = this.props

    if (typeof window !== 'undefined') {
      this.handlerFinancingForm(this.props)
      window.localStorage.setItem('ad_detail_url', location.pathname)
      sendDispatchEvent('verParcelas')
      history.push(`/comprar/financiamento/${ad.UniqueId}?lkid=2462`)
    } else {
      clickScrollSimulation()
      sendDispatchEvent('verParcelas')
    }
  }

  handleBlur(event, eventId) {
    if (!onClientSide()) return

    const { value } = event.target;
    if (value.trim()) {
      sendDispatchEvent(eventId);
    }
  }

  renderSendMessage() {
    let hyundai
    if (this.props.dataForm && this.props.dataForm.hyundaiGroup != undefined) {
      hyundai = this.props.dataForm.hyundaiGroup
    }

    return (
      <Fragment>
        <div ref={'FormsSendProposal'} className="Forms__vehicleSendProposal">
          <div className="Forms__vehicleSendProposal__container-scroll">
            <div
              ref={'proposalContainer'}
              className={
                'Forms__vehicleSendProposal__container' +
                (this.state.fixedForms && this.state.fixedForms == 'fixed'
                  ? ' Forms__vehicleSendProposal__container--fixed'
                  : '') +
                (this.state.fixedForms && this.state.fixedForms == 'bottom'
                  ? ' Forms__vehicleSendProposal__container--static'
                  : '') +
                (this.state.fixedForms && this.state.fixedForms == 'bottom' && this.props.showMedia ? ' with-ad' : '' )
              }
            >
              <div
                className="Forms__vehicleSendProposal__container__info-form"
                ref={'proposalInnerContainer'}
              >
                {!this.props.vipAutopago ? (
                  <Button
									  className={!hyundai ? "Forms__linkFinances" : "Forms__linkFinancesHyundai"}
                    onClick={this.handleClickSeeParcels}
                    dataQA="lnk_verparcelas"
                  >
                    Ver parcelas
                    {!hyundai &&
                      <div class="Forms__linkFinances__icon" />
                    }
                  </Button>
                ) : null}
                {this.props.dataForm &&
                  config.signatureIds.includes(this.props.dataForm.sellerId) ? (
                  <Fragment>
                    <b className="Forms__vehicleSendProposal__container__signature Forms__vehicleSendProposal__container__signature--top">
                      A partir de
                    </b>
                    <strong
                      id="vehicleSendProposalPrice"
                      className={`${this.props.basicInformations.price.length > 15
                        ? 'Forms__vehicleSendProposal__container__price-resize'
                        : 'Forms__vehicleSendProposal__container__price Forms__vehicleSendProposal__container__price--signature'
                        }`}
                    >
                      {this.props.basicInformations.price}
                    </strong>
                    <b className="Forms__vehicleSendProposal__container__signature Forms__vehicleSendProposal__container__signature--bottom">
                      assinatura mensal
                    </b>
                  </Fragment>
                ) : (
                  <strong
                    id="vehicleSendProposalPrice"
                    className={`${this.props.basicInformations.price.length > 15
                      ? 'Forms__vehicleSendProposal__container__price-resize'
                      : 'Forms__vehicleSendProposal__container__price'
                      }`}
                  >
                    {this.props.basicInformations.price}
                  </strong>
                )}
                <strong className="Forms__vehicleSendProposal__container__send-message-seller">
                  {this.props.dataForm &&
                    config.signatureIds.includes(this.props.dataForm.sellerId) ? (
                    <Fragment>
                      <span>Tem interesse em assinar este carro?</span>
                      <span>
                        Faça um pré-cadastro e seja um dos primeiros a
                        aproveitar esta novidade.
                      </span>
                    </Fragment>
                  ) : (
                    'Envie uma mensagem ao vendedor'
                  )}
                </strong>
                <form
                  autoComplete="off"
                  className="Forms__cookie Forms__cookie--send-proposal"
                >
                  <div className={'Forms__cookie__stage'}>
                    {this.cookiesState.formData &&
                      this.state.fullNameCookie &&
                      !this.state.editForm ? (
                      <div
                        className={
                          'Forms__cookie__items Forms__cookie__items--name'
                        }
                      >
                        <p>{this.state.fullNameCookie}</p>
                      </div>
                    ) : (
                      <Input
                        type={'text'}
                        showErrors={this.state.fullNameError}
                        formValidation={this.formValidation}
                        className={'Form__field--name'}
                        name={'fullName'}
                        label={'Nome*'}
                        onChange={this.handleChangeInputs}
                        onBlur={e =>
                          this.handleBlur(e, 'preencheuNomeLeadForm')
                        }
                        value={this.state.fullName}
                        regex={'surname'}
                        required={{ minChars: 3 }}
                        maxLength={100}
                        ref={'nameInput'}
                      />
                    )}
                    {this.state.emailCookie && !this.state.editForm ? (
                      <div
                        className={
                          'Forms__cookie__items Forms__cookie__items--email'
                        }
                      >
                        <p>{this.state.emailCookie}</p>
                      </div>
                    ) : (
                      <Input
                        type={'email'}
                        showErrors={this.state.emailError}
                        formValidation={this.formValidation}
                        name={'email'}
                        label={'E-mail*'}
                        className={'Form__field--email'}
                        onChange={this.handleChangeInputs}
                        onBlur={e =>
                          this.handleBlur(e, 'preencheuEmailLeadForm')
                        }
                        value={this.state.email}
                        regex={'email'}
                        required={{ minChars: 3, maxChars: 150 }}
                        maxLength={60}
                        ref={'emailInput'}
                      />
                    )}
                    {this.state.numberPhoneCookie && !this.state.editForm ? (
                      <div
                        className={
                          'Forms__cookie__items Forms__cookie__items--numberphone'
                        }
                      >
                        <p>{this.state.numberPhoneCookie}</p>
                      </div>
                    ) : (
                      <Input
                        type={'tel'}
                        showErrors={this.state.numberPhoneError}
                        formValidation={this.formValidation}
                        name={'numberPhone'}
                        label={'Telefone*'}
                        className={'Form__field--phone'}
                        onChange={this.handleChangeInputs}
                        onBlur={e =>
                          this.handleBlur(e, 'preencheuTelefoneLeadForm')
                        }
                        value={this.state.numberPhone}
                        regex={'numberPhone'}
                        ref={'phoneInput'}
                      />
                    )}
                    {this.state.buttonEdit ? (
                      <div
                        className={'Forms__cookie__edit-information'}
                        onClick={this.editForm.bind(this)}
                      >
                        Editar informações
                      </div>
                    ) : undefined}
                    <Input
                      type="text"
                      showErrors={this.state.messageError}
                      formValidation={this.formValidation}
                      name="message"
                      label="Mensagem*"
                      className="Form__field--message"
                      onChange={this.handleChangeInputs}
                      onBlur={e =>
                        this.handleBlur(e, 'preencheuMensagemLeadForm')
                      }
                      value={this.state.message}
                      required={{ minChars: 10 }}
                      ref={'msgInput'}
                    />
                    {!this.state.newsletterCookie || this.state.editForm ? (
                      <div className={'Form__field Form__field--checkbox'}>
                        <label className="Checkbox Label--contact">
                          <input
                            type="checkbox"
                            name="newsletter"
                            id="newsletter"
                            checked={this.state.newsletter}
                            className="Form__TextInput"
                            onChange={event => {
                              this.handleCheckChange(event.target.checked)
                            }}
                          />
                          Quero receber contatos da Webmotors por e-mail,
                          WhatsApp e outros canais.
                        </label>
                      </div>
                    ) : undefined}
                  </div>
                </form>
                <Button
                  className={` Button--red Button--send-message Button--send-proposal ${this.state.showFormErrors && !this.state.ABFormTest
                    ? 'Button--disabled'
                    : ''
                    }`}
                  name="ButtonSendProposal"
                  id="ButtonSendProposal"
                  value="ButtonSendProposal"
                  type="submit"
                  onClick={this.sendProposal}
                >
                  {this.props.dataForm &&
                    config.signatureIds.includes(this.props.dataForm.sellerId)
                    ? 'Tenho interesse'
                    : this.state.loadingMessage
                      ? 'Enviando...'
                      : 'Enviar mensagem'}
                </Button>
              </div>
              {this.props.showMedia && (
                <AdPlacement
                  id="sidebar"
                  type="sidebar"
                  shouldDisplayMidias={this.props.showMedia}
                />
              )}
            </div>
          </div>
        </div>
      </Fragment>
    )
  }

  setCarDeliveryValue = wantCarDelivery => {
    this.setState({ wantCarDelivery })
  }
  render() {
    return (
      <FormDetails className={'Forms--send-proposal'} id={'SendProposal'}>
        {this.renderSendMessage()}
      </FormDetails>
    )
  }
}
export default withCookieNotice(
  withRouter(
    connect(store => {
      return {
        proposal: store.proposalState,
      }
    })(SendProposal)
  )
)
